import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';
import Alerts from '../../utils/alerts';

import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    Switch
} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    }
}));

const Create = ({ item, open, closeCreation, createValues, dependencies, updateDependencies }) => {

    const classes = useStyles();

    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});

    const changeEmpresa = (event, values) => {
        values = {
            ...values,
            empresa: event.target.value,
            ENGENHEIRO: null,
            REGIAO: null,
            EQUIPE: null,
            gso: null,
            gerenciadora: null,
            tipo: null,
            TIPO: null,
            GERENCIADORA: null
        };
        updateDependencies(values);
    }

    const changeUF = (event, values) => {
        values = { ...values, uf: event.target.value, MUNICIPIO: null, municipio: {} };
        updateDependencies(values);
    };

    const changeEquipe = (event, values) => {
        values = { ...values, EQUIPE: event.target.value, REGIAO: null };
        updateDependencies(values);
    };

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    return (
        <Fragment>

            <Alerts message={message}
                open={openAlert}
                closeAlert={closeAlert} />

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" className={classes.root} >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Unidade
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                codigo: Yup.string().max(20).required('A seleção da unidade é obrigatório'),
                                nome: Yup.string().required('O nome da unidade é obrigatório'),
                                TIPO: Yup.string().required('O Tipo de unidade é obrigatório'),
                                MUNICIPIO: Yup.string().required('O Município da unidade é obrigatório'),
                                empresa: Yup.string().required('O Cliente da unidade é obrigatório'),
                                EQUIPE: Yup.string().required('A Equipe é obrigatória'),
                                REGIAO: Yup.string().required('A Região é obrigatório'),
                                ENGENHEIRO: Yup.string().required('O Engenheiro Responsável é obrigatório'),
                                GERENCIADORA: Yup.string().required('A Gerenciadora é obrigatório')
                            })
                        }
                        onSubmit={(values, formik) => {
                            createValues(values);
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>

                                <Box className={classes.fieldset} >

                                    <Grid
                                        container
                                        spacing={2}
                                        xs="auto"
                                    >
                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.codigo && errors.codigo)}
                                                fullWidth
                                                required
                                                label="Código"
                                                margin="normal"
                                                name="codigo"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.codigo}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.nome && errors.nome)}
                                                fullWidth
                                                required
                                                label="Nome"
                                                margin="normal"
                                                name="nome"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.nome}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin="normal">
                                                <InputLabel shrink htmlFor="empresa" required>Cliente</InputLabel>
                                                <Select
                                                    notched
                                                    shrink
                                                    autosize={true}
                                                    error={Boolean(touched.empresa && errors.empresa)}
                                                    helperText={touched.empresa && errors.empresa}
                                                    value={values.empresa}
                                                    onChange={e => {
                                                        handleChange(e);
                                                        changeEmpresa(e, values);
                                                    }}
                                                    onBlur={handleBlur}
                                                    label="Cliente"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'empresa',
                                                        id: 'empresa'
                                                    }}

                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.companies.map((empresa) => (
                                                        <MenuItem key={empresa.id} value={empresa.id}>{empresa.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth >
                                                <InputLabel shrink htmlFor="TIPO" required >Tipo de Unidade</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    error={Boolean(touched.TIPO && errors.TIPO)}
                                                    helperText={touched.TIPO && errors.TIPO}
                                                    value={values.TIPO}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Tipo de Ocorrência"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'TIPO',
                                                        id: 'TIPO',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.types.map((tipo) => (
                                                        <MenuItem key={tipo.id} value={tipo.id}>{tipo.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink htmlFor="ENGENHEIRO" required>Engenheiro responsável</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    required
                                                    error={Boolean(touched.ENGENHEIRO && errors.ENGENHEIRO)}
                                                    helperText={touched.ENGENHEIRO && errors.ENGENHEIRO}
                                                    value={values.ENGENHEIRO}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Engenheiro responsável"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'ENGENHEIRO',
                                                        id: 'ENGENHEIRO',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.engineers.map((engenheiro) => (
                                                        <MenuItem key={engenheiro.id} value={engenheiro.id}>{engenheiro.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink htmlFor="GERENCIADORA" required>Gerenciadora</InputLabel>
                                                <Select
                                                    notched
                                                    autosize={true}
                                                    error={Boolean(touched.GERENCIADORA && errors.GERENCIADORA)}
                                                    helperText={touched.GERENCIADORA && errors.GERENCIADORA}
                                                    value={values.GERENCIADORA}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Gerenciadora"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'GERENCIADORA',
                                                        id: 'GERENCIADORA',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.controllers.map((gerenciadora) => (
                                                        <MenuItem key={gerenciadora.id} value={gerenciadora.id}>{gerenciadora.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>
                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.fiscal && errors.fiscal)}
                                                fullWidth
                                                label="Fiscal"
                                                margin="none"
                                                name="fiscal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.fiscal}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>
                                        <Grid
                                            item
                                            md={4}
                                            xs={4}>

                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink htmlFor="atendType" required>Equipe Técnica</InputLabel>
                                                <Select
                                                    notched
                                                    required
                                                    autosize={true}
                                                    error={Boolean(touched.EQUIPE && errors.EQUIPE)}
                                                    helperText={touched.EQUIPE && errors.EQUIPE}
                                                    value={values.EQUIPE}
                                                    onChange={e => {
                                                        handleChange(e);
                                                        changeEquipe(e, values);
                                                    }}
                                                    onBlur={handleBlur}
                                                    label="Equipe Técnica"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'EQUIPE',
                                                        id: 'EQUIPE',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.teams.map((equipe) => (
                                                        <MenuItem key={equipe.id} value={equipe.id}>{equipe.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink htmlFor="atendType" required>Região de Atendimento</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    error={Boolean(touched.REGIAO && errors.REGIAO)}
                                                    helperText={touched.REGIAO && errors.REGIAO}
                                                    value={values.REGIAO}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Região de Atendimento"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'REGIAO',
                                                        id: 'REGIAO',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.regions.map((regiao) => (
                                                        <MenuItem key={regiao.id} value={regiao.id}>{regiao.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink htmlFor="gso">GSO</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    error={Boolean(touched.gso && errors.gso)}
                                                    helperText={touched.gso && errors.gso}
                                                    value={values.gso}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="GSO"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'gso',
                                                        id: 'gso',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.managers.map((gso) => (
                                                        <MenuItem key={gso.id} value={gso.id}>{gso.regional}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.cnpj && errors.cnpj)}
                                                fullWidth
                                                label="CNPJ"
                                                margin="none"
                                                name="cnpj"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.cnpj}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={8}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.endereco && errors.endereco)}
                                                fullWidth
                                                label="Endereço"
                                                margin="none"
                                                name="endereco"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.endereco}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.bairro && errors.bairro)}
                                                fullWidth
                                                label="Bairro"
                                                margin="none"
                                                name="bairro"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.bairro}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink htmlFor="uf">UF</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    error={Boolean(touched.uf && errors.uf)}
                                                    helperText={touched.uf && errors.uf}
                                                    value={values.uf}
                                                    onChange={e => {
                                                        handleChange(e);
                                                        changeUF(e, values);
                                                    }}
                                                    onBlur={handleBlur}
                                                    label="UF"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'uf',
                                                        id: 'uf',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.states.map((uf) => (
                                                        <MenuItem key={uf.UF} value={uf.UF}>{uf.UF}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>
                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink htmlFor="MUNICIPIO">Município</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    required
                                                    error={Boolean(touched.MUNICIPIO && errors.MUNICIPIO)}
                                                    helperText={touched.MUNICIPIO && errors.MUNICIPIO}
                                                    value={values.MUNICIPIO}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Município"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'MUNICIPIO',
                                                        id: 'MUNICIPIO',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.cyties.map((municipio) => (
                                                        <MenuItem key={municipio.id} value={municipio.id}>{municipio.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={3}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.cep && errors.cep)}
                                                fullWidth
                                                label="CEP"
                                                margin="none"
                                                name="cep"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.cep}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={3}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.telefone && errors.telefone)}
                                                fullWidth
                                                label="Telefone"
                                                margin="none"
                                                name="telefone"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.telefone}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>


                                        <Grid
                                            item
                                            md={3}
                                            xs={12}>
                                            <TextField
                                                error={Boolean(touched.latitude && errors.latitude)}
                                                fullWidth
                                                helperText={touched.latitude && errors.latitude}
                                                label="Latitude no Mapa"
                                                margin="none"
                                                name="latitude"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.latitude}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            md={3}
                                            xs={12}>
                                            <TextField
                                                error={Boolean(touched.longitude && errors.longitude)}
                                                fullWidth
                                                helperText={touched.longitude && errors.longitude}
                                                label="Longitude no Mapa"
                                                margin="none"
                                                name="longitude"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.longitude}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            md={3}
                                            xs={12}>
                                            <Typography
                                                color="textPrimary"
                                                gutterBottom
                                                variant="h6"
                                            >
                                                Ativa / Inativa
                                            </Typography>
                                            <Switch
                                                checked={values.ativa}
                                                onChange={handleChange}
                                                name="ativa" />
                                        </Grid>


                                        <Grid
                                            item
                                            xs={12}
                                        >
                                            <TextField
                                                error={Boolean(touched.obs && errors.obs)}
                                                fullWidth
                                                helperText="Coloque aqui comentário ou justificativa a respeito da unidade (1024 caracteres)."
                                                label="Observações sobre a Unidade"
                                                rows={2}
                                                size={10}
                                                length={1024}
                                                multiline
                                                margin="none"
                                                name="obs"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.obs}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                    </Grid>

                                </Box>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeCreation() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Create;
